import { render, staticRenderFns } from "./studentStatistic.vue?vue&type=template&id=373ccde4&scoped=true&"
import script from "./studentStatistic.vue?vue&type=script&lang=js&"
export * from "./studentStatistic.vue?vue&type=script&lang=js&"
import style0 from "./studentStatistic.vue?vue&type=style&index=0&id=373ccde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ccde4",
  null
  
)

export default component.exports